module.exports = __webpack_public_path__ + "img/VISA-MC.0e963e23.png";